import { fetchApi } from '@/config/axiosSetting';
import {
  GetAdjusterOpinionFunctionParamsType,
  GetAdjusterOpinionQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/getAdjusterOpinion/getAdjusterOpinionQuery.type';

export const getAdjusterOpinionFunction = (
  params: GetAdjusterOpinionFunctionParamsType,
): Promise<GetAdjusterOpinionQueryResponseType> => {
  return fetchApi.get(`${params.id}/report/adjuster_opinion/`);
};
